export default {
    data: {
        // 轮播图模块==============
        swi: {
            url1: "https://pro.m.jd.com/mall/active/3s4A3dfrTy9K6FTXZWd1U67xJ9VR/index.html?babelChannel=ttt6&__jda=76161171.16219459397471095426355.1621945940.1622081888.1622085517.7",
            url2: "https://pro.m.jd.com/mall/active/gRZyDaEmXLBczatazfFr8E6hx37/index.html?extension_id=eyJhZCI6IjM2MjEiLCJjaCI6IjIiLCJzaG9wIjoiMTM4NDk5IiwidHMiOiIxNjIyMDg1NDc4IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcIjE5ODIxN2JiLTk3NzQtNDdiNi05MzJiLTg1OTE0ZGJjNjhhZlwiLFwibWF0ZXJpYWxfaWRcIjpcIjM4NTE5NTkxOTRcIixcInBvc19pZFwiOlwiMzYyMVwiLFwic2lkXCI6XCIxOWQzZDYyNC0xNGJhLTRiYTAtYTU4OS02NWRmZThiN2NlNDRcIn0ifQ==&jd_pop=198217bb-9774-47b6-932b-85914dbc68af&abt=1",
            url3: "https://sale.jd.com/m/h5/kmdtjsgth1tm.html?extension_id=eyJhZCI6IjM2MjIiLCJjaCI6IjIiLCJzaG9wIjoiMTAxNjk3NjciLCJ0cyI6IjE2MjIwODU0OTYiLCJ1bmlxaWQiOiJ7XCJjbGlja19pZFwiOlwiNjg5NzNmOTgtYjlhMy00NjZiLWEzYzItMzMxZjYxZmQwOTM1XCIsXCJtYXRlcmlhbF9pZFwiOlwiMzk2NjQxOTExMFwiLFwicG9zX2lkXCI6XCIzNjIyXCIsXCJzaWRcIjpcImNmNWQ3YzI3LThlYTgtNGFhYy04OWI5LTEzYTMxNDAwMGQxZlwifSJ9&jd_pop=68973f98-b9a3-466b-a3c2-331f61fd0935&abt=1",
            url4: "https://prodev.m.jd.com/mall/active/XSLZKjWxASg9S8RnURtRuKY7Phz/index.html?__jda=76161171.16219459397471095426355.1621945940.1622081888.1622085517.7",
            url5: "https://prodev.m.jd.com/mall/active/s8XApRQJYya3nKuVaH66e2qVcpM/index.html?__jda=76161171.16219459397471095426355.1621945940.1622081888.1622085517.7",
            url6: "https://shop.m.jd.com/?shopId=1000010241&extension_id=eyJhZCI6IjM2MjMiLCJjaCI6IjIiLCJzaG9wIjoiMTAwMDAxMDI0MSIsInRzIjoiMTYyMjA4NTU1MyIsInVuaXFpZCI6IntcImNsaWNrX2lkXCI6XCJlNTU1NmZkZC1jMzdjLTRmMDItOWFlNC1hMzFhNzE4OWI4MjhcIixcIm1hdGVyaWFsX2lkXCI6XCIzOTkzMTkxMzE1XCIsXCJwb3NfaWRcIjpcIjM2MjNcIixcInNpZFwiOlwiM2EwZTJjNmYtOTRjZi00MjFhLWIyMDQtNWY1MjVjODc2YTEzXCJ9In0=&jd_pop=e5556fdd-c37c-4f02-9ae4-a31a7189b828&abt=1",
            img1: "//m.360buyimg.com/mobilecms/s700x280_jfs/t1/196543/40/3929/128390/60a4c55fEe2f4c6ff/eaee8ff794aa9154.jpg!cr_1053x420_4_0!q70.jpg.dpg",
            img2: "//m.360buyimg.com/mobilecms/s700x280_jfs/t1/196722/15/2276/104020/6099084bE9188bc61/433760fa07a1ac91.jpg!cr_1053x420_4_0!q70.jpg.dpg",
            img3: "//m.360buyimg.com/mobilecms/s700x280_jfs/t1/173119/1/10181/89612/60a22858E3a68ab07/10c5d6e89f951de7.jpg!cr_1053x420_4_0!q70.jpg.dpg",
            img4: "//m.360buyimg.com/mobilecms/s700x280_jfs/t1/167245/17/13432/149823/60540ceeE0a928512/677088217d8a00aa.jpg!cr_1053x420_4_0!q70.jpg.dpg",
            img5: "//m.360buyimg.com/mobilecms/s700x280_jfs/t1/179685/5/6022/112674/60ae01b7Ecd5597b7/7740fe0e137b61a1.jpg!cr_1053x420_4_0!q70.jpg.dpg",
            img6: "//m.360buyimg.com/mobilecms/s700x280_jfs/t1/183539/34/4935/108527/60a4e45cE59b32ab2/777fc395575a8b9a.jpg!cr_1053x420_4_0!q70.jpg.dpg",
        },
        // 领百亿券模块============
        floor: {
            url1: "https://prodev.m.jd.com/mall/active/3rYoPdU4pC1keHYWPdjVMTFTp5ea/index.html?innerLink=%5B%7B%22matId%22%3A%22100016724434%22%2C%22groupId%22%3A%2215763697%22%2C%22matType%22%3A%220%22%7D%5D",
            url2: "https://h5.m.jd.com/babelDiy/Zeus/2FWqhF1Ecpuhtub7ZKAf6c8WvDjs/index.html?babelChannel=ttt17&innerLink=%5B%7B%22matId%22%3A%2229607710162%22%2C%22groupId%22%3A%2204014712%22%2C%22themeId%22%3A%2230328%22%2C%22matType%22%3A%2210%22%7D%2C%7B%22matId%22%3A%22100004840981%22%2C%22groupId%22%3A%2204014712%22%2C%22themeId%22%3A%2213991%22%2C%22matType%22%3A%2210%22%7D%5D#/",
            url3: "https://h5.m.jd.com/babelDiy/Zeus/2FWqhF1Ecpuhtub7ZKAf6c8WvDjs/index.html?babelChannel=ttt17&innerLink=%5B%7B%22matId%22%3A%2229607710162%22%2C%22groupId%22%3A%2204014712%22%2C%22themeId%22%3A%2230328%22%2C%22matType%22%3A%2210%22%7D%2C%7B%22matId%22%3A%22100004840981%22%2C%22groupId%22%3A%2204014712%22%2C%22themeId%22%3A%2213991%22%2C%22matType%22%3A%2210%22%7D%5D#/",
            url4: "https://prodev.m.jd.com/mall/active/2hnABLCfAVUb9WvoQVgUvA6kDVjf/index.html?innerLink=%5B%7B%22matId%22%3A%2210023743892730%22%2C%22groupId%22%3A%2215684653%22%2C%22matType%22%3A%220%22%7D%5D",
            img1: "//m.360buyimg.com/n1/jfs/t1/172257/38/11680/72329/60ae0494Ea02d1399/9e39b3a319e5949d.jpg!q70.jpg",
            img2: "//m.360buyimg.com/n1/jfs/t1/176629/15/11342/47191/60acb1eeE1a3c246a/aee1a633c8da7a88.jpg!q70.jpg",
            img3: "//m.360buyimg.com/n1/jfs/t1/106851/34/461/375825/5dae7dbcEa0b17dc2/5dc110597ce8fc6b.jpg!q70.jpg",
            img4: "//m.360buyimg.com/n1/jfs/t1/181768/19/3814/376502/609ce5b8E9f2d453a/28a8991f90ef87a8.jpg!q70.jpg",
        },
        // 京东超市轮播第一页=============
        fl1: [{
                url: "https://h5.m.jd.com/babelDiy/Zeus/4JkCVz6z5RB4dBL7bZBwtGRiBLLw/index.html?hideTabbar=true",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/125678/35/5947/4868/5efbf28cEbf04a25a/e2bcc411170524f0.png.webp",
                num: "京东超市",
            },
            {
                url: "https://pro.m.jd.com/mall/active/8tHNdJLcqwqhkLNA8hqwNRaNu5f/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/135931/4/3281/5598/5efbf2c0Edbdc82c7/ed9861b4ddfb9f30.png.webp",
                num: "数码电器",
            },
            {
                url: "https://pro.m.jd.com/mall/active/3qMkfmPMc55RTahmSSpwwuxVrYMG/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/140012/8/1804/3641/5efbf318E38bd5dad/0db99d859ab16ce9.png.webp",
                num: "京东服饰",
            },
            {
                url: "https://pro.m.jd.com/mall/active/4P9a2T9osR9JvtzHVaYTPvsecRtg/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/129215/21/5978/3618/5efbf344Ebec23ae8/59712d986b10bb0a.png.webp",
                num: "京东生鲜",
            },
            {
                url: "https://daojia.jd.com/html/index/index.html?channel=jdapp",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/116602/7/11200/3796/5efbf375Ebba41029/f07cc166f368fa05.png.webp",
                num: "京东到家",
            },
            {
                url: "https://prodev.m.jd.com/mall/active/N2p5dHzdwxnAqp182PVJmc5L5Se/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/146390/3/1846/4909/5efbf39aEe5f5f797/300071558a9ab078.png.webp",
                num: "充值缴费",
            },
            {
                url: "https://m.jingxi.com/mcoss/wxmall/home?_fd=jx&ptag=17008.1.14&&ptype=2&nodrainage=1&showFootNav=0",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/179511/33/4023/3422/609e0d45Ea495a996/3783165b48cf1e08.png.webp",
                num: "9.9元拼",
            },
            {
                url: "https://coupon.m.jd.com/center/getCouponCenter.action",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/113589/24/11332/4897/5efbf3feE705d87db/e5c12d5e943266b9.png.webp",
                num: "领券",
            },
            {
                url: "https://active.jd.com/forever/cashback/?channellv=mapp",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/131663/33/3380/3674/5efbf50fEf79cf314/af4b57d2383e605d.png.webp",
                num: "领津贴",
            },
            {
                url: "https://plogin.m.jd.com/login/login?appid=461&returnurl=http%3A%2F%2Fhome.m.jd.com%2Fuser%2FuserAllOrderList.action&ipChanged=false",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/123730/37/5924/4189/5efbf567E0a226121/d04df7c74c87cf68.png.webp",
                num: "PLUS会员",
            },
        ],
        // 京东超市轮播第二页=============
        fl2: [{
                url: "https://pro.m.jd.com/mall/active/3YvKJrc4e4WK7aZ46j3h5UMCvEn4/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/142596/7/1864/4759/5efbf5a9E60c62b8a/49cdd24cb2bfecf5.png.webp",
                num: "京东国际",
            },
            {
                url: "https://zpsy.jd.com/",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/125193/15/5993/3443/5efbf5dbEa3327124/a4282d5cb2879c8b.png.webp",
                num: "京东拍卖",
            },
            {
                url: "https://pro.m.jd.com/mall/active/2aiozXgZK1PUVZA37WNq62KLtjcC/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/133947/24/3428/4213/5efbf625E7e1b4e98/95fda84d8748f88d.png.webp",
                num: "唯品会",
            },
            {
                url: "https://pro.m.jd.com/mall/active/3JAoyewPmdVBMeRWTBiHDdGH5M36/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/145692/9/1817/4493/5efbf652E61c4f3ec/722840c121d67fc6.png.webp",
                num: "玩3C",
            },
            {
                url: "https://pro.m.jd.com/mall/active/3d34Pm49obpjLEdhhagSZuM5QrwC/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/118396/30/11271/2692/5efbf680Eb3a3cf32/c3e85c4d99746400.png.webp",
                num: "沃尔玛",
            },
            {
                url: "https://pro.m.jd.com/mall/active/2kmaPNrGDNYo1LKwYtRoaSmsgbj6/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/123571/19/6008/3747/5efbf6b2E03153a36/9ddc9036ba1c11a1.png.webp",
                num: "美妆馆",
            },
            {
                url: "https://pro.m.jd.com/mall/active/4Fr34Vshk1ymvv9CBTysFkF36aYM/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/115003/18/11199/3519/5efbf6eaEe59cb7f6/dab44230606cd112.png.webp",
                num: "京东旅行",
            },
            {
                url: "https://pro.m.jd.com/mall/active/LHGZv1DrGkva1jNpUkKFuNFN6oo/index.html",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/142258/17/1800/4509/5efbf70aEb23e164e/61aaea8fe5221081.png.webp",
                num: "拍拍二手",
            },
            {
                url: "https://plogin.m.jd.com/login/login?appid=461&returnurl=http%3A%2F%2Fhome.m.jd.com%2Fuser%2FuserAllOrderList.action&ipChanged=false",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/116056/30/11288/4223/5efbf753Ee7cf2cd7/3977b5fe42b136e4.png.webp",
                num: "物流查询",
            },
            {
                url: "https://m.jd.com/portal/app_center.shtml",
                img: "//m.360buyimg.com/mobilecms/s120x120_jfs/t1/112559/35/11283/3523/5efbf774E285d108b/c0fa626df4979a21.png.webp",
                num: "全部",
            },

        ],
        ms: [{
                num1: "￥1399",
                num2: "￥1599",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=10026245185679&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/181985/16/6038/173442/60aef0cbEe03ee96c/9236817a10874985.jpg.dpg"
            }, {
                num1: "￥938",
                num2: "￥1298",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=10026259230457&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/127293/32/19484/133194/60b050baE9b88444e/36dfffd3316238b4.jpg.dpg"
            },
            {
                num1: "￥59.9",
                num2: "￥69.9",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=25379831718&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/186702/18/3616/192284/60a1dac3E5ad8823a/47b8287603060fbe.jpg.dpg"
            },
            {
                num1: "￥1889",
                num2: "￥2099",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=49456186753&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/177968/36/5039/78709/60a61995Eaefb1cda/7147b452039a3e65.jpg.dpg"
            },
            {
                num1: "￥16.8",
                num2: "￥50.4",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=10026652940973&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/185291/21/4937/109025/60a5bc6dEdc83ab70/6a6f0cc59a3b448b.jpg.dpg"
            },
            {
                num1: "￥19.9",
                num2: "￥23.9",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=12572817&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/98455/27/15677/250464/5e732a71E0c77eff2/1bfd3bd371c82f84.jpg.dpg"
            },
            {
                num1: "￥26.9",
                num2: "￥29.9",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=100009576107&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/183627/13/5710/58951/60ab9dcaE3e1de5d6/59e784e3f034b092.jpg.dpg"
            },
            {
                num1: "￥22.9",
                num2: "￥29.8",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=1863219&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/162744/1/3481/112315/600800b5Edb349374/b0d10d7bd43ebbfb.jpg.dpg"
            },
            {
                num1: "￥3699",
                num2: "￥4299",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=100021137506&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/178891/38/6274/77994/60b08811E53eea5d6/640b58c83a1d821f.jpg.dpg"
            },
            {
                num1: "￥3899",
                num2: "￥5399",
                url: "https://wqs.jd.com/portal/wx/seckill_m/index.shtml?wareId=47878949717&st=1",
                img: "//img11.360buyimg.com/n7/s150x150_jfs/t1/193816/30/4329/166778/60a86249Ebddd48a1/9d8092a8ac2af27a.jpg.dpg"
            },
        ],
        jx: [{
                num1: "新潮手机榜",
                num2: "新机遇好礼",
                url: "https://prodev.m.jd.com/mall/active/4F1ztmVzKEoEiSs3RfYwU4u2Um3g/index.html?innerLink=%5B%7B%22matId%22%3A%22100015844954%22%2C%22groupId%22%3A%2215676610%22%2C%22matType%22%3A%220%22%7D%5D",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/131061/39/11365/86022/5f7430a3E70e693e4/d57b22a37a1b2c5f.jpg!q70.jpg.dpg"
            }, {
                num1: "爆款预售",
                num2: "超值预售",
                url: "https://prodev.m.jd.com/mall/active/2Uq8anMmZ9HF7iES67VUCJk5KrMV/index.html?innerLink=%5B%7B%22matId%22%3A%2210026268071012%22%2C%22groupId%22%3A%2215572714%22%2C%22matType%22%3A%220%22%7D%5D",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/171575/11/2767/104043/6000f6e0Ebe443b58/e1037d97b1cdf42e.jpg!q70.jpg.dpg"
            },
            {
                num1: "焕新家电",
                num2: "新品预售",
                url: "https://prodev.m.jd.com/mall/active/4BonccBkFBPS1QaKtpFxo1KQsh8R/index.html",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/174144/6/10884/11357/60a7714dE708c334a/67510bc91ce963fb.jpg!q70.jpg.dpg"
            },
            {
                num1: "个性定制",
                num2: "心愿定制",
                url: "https://prodev.m.jd.com/mall/active/38Dmzz1C31TeDddjB8MyVpCQtCvk/index.html?innerLink=%5B%7B%22matId%22%3A%2210026025781724%22%2C%22groupId%22%3A%2215589284%22%2C%22matType%22%3A%220%22%7D%5D",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/173053/27/11903/259794/60b0a7e5E95b21749/65b25786d63c634e.jpg!q70.jpg.dpg"
            },
            {
                num1: "京东汽车",
                num2: "满300减20",
                url: "https://prodev.m.jd.com/mall/active/S3QUuShiWbciWDsoubQtG29Ejn5/index.html?babelChannel=ttt1&innerLink=%5B%7B%22matId%22%3A%22782924%22%2C%22groupId%22%3A%2213929389%22%2C%22matType%22%3A%220%22%7D%5D",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/190418/28/5236/340923/60af7ddcE54327c7a/16b4149058d6723b.jpg!q70.jpg.dpg"
            },
            {
                num1: "智能数码",
                num2: "潮人必备",
                url: "https://prodev.m.jd.com/mall/active/2KSTQy4m2T7c9wG5hcG4Vv2qJmns/index.html?babelChannel=ttt12&innerLink=%5B%7B%22matId%22%3A%22100006651399%22%2C%22groupId%22%3A%2215301546%22%2C%22matType%22%3A%220%22%7D%5D",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/173128/32/5719/220143/607fefeeEe6008586/b91a155a2378d7e4.jpg!q70.jpg.dpg"
            },
            {
                num1: "儿童节好礼",
                num2: "部分5折",
                url: "https://prodev.m.jd.com/mall/active/jpfNFqEfo9m2zWbA165ktkR7uHt/index.html?babelChannel=ttt6&innerLink=%5B%7B%22matId%22%3A%22100012495828%22%2C%22groupId%22%3A%2215669148%22%2C%22matType%22%3A%220%22%7D%5D",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/151885/3/12120/148203/5fe98e72E9a1c5a68/2c02eca493973154.jpg!q70.jpg.dpg"
            },
            {
                num1: "奢侈钟表",
                num2: "低至5折",
                url: "https://prodev.m.jd.com/mall/active/4V4vX3zGwQCPFvU94PeLHN3QjGHp/index.html?innerLink=%5B%7B%22matId%22%3A%22100008752787%22%2C%22groupId%22%3A%2215669405%22%2C%22matType%22%3A%220%22%7D%5D",
                img: "//m.360buyimg.com/n1/s240x240_jfs/t1/181628/18/5694/68828/60ab39fdE93941c9e/011e080efd4b1b27.jpg!q70.jpg.dpg"
            },

        ],
        dxx1: {
            img1: "//img12.360buyimg.com/n2/s308x308_jfs/t1/191163/37/5522/312276/60b1f1beE9c19656b/7ac00e56b831995b.jpg!q70.dpg",
            img2: "//img13.360buyimg.com/n2/s308x308_jfs/t1/132026/10/16091/85397/60b0cfe8Eef1a25f4/8b9f534cc123e6c0.jpg!q70.dpg",
            img3: "//img10.360buyimg.com/n2/s308x308_jfs/t1/175743/31/11939/85016/60b0e04eE240c613f/5bc5dd444bbb22fb.jpg!q70.dpg",
            img4: "//img12.360buyimg.com/n2/s308x308_jfs/t1/192987/26/5443/80725/60b0e894Ea66f9ca4/221f69b5ea601c4e.jpg!q70.dpg",
            img5: "//img10.360buyimg.com/n2/s308x308_jfs/t1/186008/26/5610/460999/60ac50c5E25822992/816a2dbaf4b00295.jpg!q70.dpg",
        },
        sp: [{
                num1: "Apple iPhone 11 (A2223) 128GB 白色 移动联通电信4G手机 双卡双待",
                num2: "5199",
                num3: "苹果手机旗舰店",
                url1: "/indexs1",
                img1: "//img10.360buyimg.com/mobilecms/s372x372_jfs/t1/180974/9/6325/191463/60b0ab7fE67acf23b/28920955cc06fcfe.jpg!q70.dpg.webp",
                num4: "华为 手机壳HUAWEI P40 PU Monogram保护壳 浅绿栅格",
                num5: "169",
                num6: "米特尔手机配件旗舰店",
                url2: "/indexs1",
                img2: "//img12.360buyimg.com/mobilecms/s372x372_jfs/t1/107838/11/18866/123550/5ec73b65E239f47c5/0e11a62cd4d398dd.jpg!q70.dpg.webp"
            },
            {
                num1: "【二手9成新】华为 畅享8 手机 安卓全网通4G 双卡双待 蓝色 4GB+64GB  ",
                num2: "449",
                num3: "华为官方旗舰店",
                url1: "/indexs1",
                img1: "//img20.360buyimg.com/mobilecms/s372x372_jfs/t1/177010/9/6051/158577/60ae7023E67001123/e3737c997af5a986.jpg!q70.dpg.webp",
                num4: "原装苹果充电器头数据线充电线手机快充插头套装适用iphonexs/11/7p/8plus/12维肯 【国行-原套装】多一条快充数据线",
                num5: "99",
                num6: "aiqi数码旗舰店",
                url2: "/indexs1",
                img2: "//img13.360buyimg.com/mobilecms/s372x372_jfs/t1/187299/14/5715/122422/60b30369E4d672e43/291e5f4da754fc66.jpg!q70.dpg.webp"
            },
            {
                num1: "JoJar苹果快充套装PD充电器20/18W充电头数据线原装适用iPhone12/11/SE2/XR/XS手机苹果PD快充套装1米                             ",
                num2: "99",
                num3: "华强北数码",
                url1: "/indexs1",
                img1: "//img13.360buyimg.com/mobilecms/s372x372_jfs/t1/133630/27/19959/77255/5fd966e8Ebb7cba5b/bb28d7e962067472.jpg!q70.dpg.webp",
                num4: "Redmi K40 旗舰骁龙870 三星AMOLED 120Hz高刷直屏 4800万高清三摄相机 33W快充 12GB+256GB 墨羽 游戏电竞智能5G手机 小米 红米",
                num5: "2699",
                num6: "redmi旗舰店",
                url2: "/indexs1",
                img2: "//img13.360buyimg.com/mobilecms/s372x372_jfs/t1/180263/5/5840/109206/60aba7a6E0c61b894/1e692df22fd41660.jpg!q70.dpg.webp"
            },
            {
                num1: "小米11 5G 骁龙888 2K AMOLED四曲面柔性屏 1亿像素 55W有线闪充 50W无线闪充 8GB+256GB 蓝色 游戏手机",
                num2: "4299",
                num3: "小米官方旗舰店",
                url1: "/indexs1",
                img1: "//img10.360buyimg.com/mobilecms/s372x372_jfs/t1/149722/3/20662/131979/60abaac4E4e2c26b8/c3181147d6c64694.jpg!q70.dpg.webp",
                num4: "决色（DEFENSE）小米11ultra手机壳5G mi11U至尊版防摔保护套金属边框全包边气囊SHIELD系列星际",
                num5: "218",
                num6: "决色数码配件旗舰店",
                url2: "/indexs1",
                img2: "//img14.360buyimg.com/mobilecms/s372x372_jfs/t1/124658/38/19032/120302/60ae3d82E32278d02/767152b1ee6979b2.jpg!q70.dpg.webp"
            },
            {
                num1: "vivo iQOO 7 12GB+256GB 传奇版 骁龙888 120W超快闪充 KPL官方赛事电竞手机 双模5G全网通vivoiqoo7",
                num2: "4198",
                num3: "IQOO旗舰店",
                url1: "/indexs1",
                img1: "//img20.360buyimg.com/mobilecms/s372x372_jfs/t1/196791/7/5285/109386/60b05a1aE084067c7/fc1a951184f0c942.jpg!q70.dpg.webp",
                num4: "realme 真我GT Neo闪速版 天玑1200 6400万索尼主摄 65W闪充 仅179g 曙光 12GB+256GB 双5g游戏手机gt",
                num5: "2499",
                num6: "realme旗舰店",
                url2: "/indexs1",
                img2: "//img10.360buyimg.com/mobilecms/s372x372_jfs/t1/178324/35/6315/227337/60b0c703Ee0298bb5/11347bb4433a4538.jpg!q70.dpg.webp"
            },
        ]

    },
};